export default {
  title: 'Arbeitsplätze aus {dataSource} importieren',
  importWorkplaces: 'Arbeitsplätze importieren',
  next: 'Weiter',
  previous: 'Zurück',
  import: 'Arbeitsplätze importieren',
  retry: 'Erneut versuchen',
  userMapping: {
    header: 'Benutzerzuordnung',
    description: 'Qmulus liest die Arbeitsplätze mit Ihrem PT9800-Benutzer und synchronisiert die importierten Arbeitsplätze mit dem PT9800-Benutzer des Systembenutzers.',
    currentUser: 'Ihr PT9800-Benutzer',
    systemUser: 'PT9800-Benutzer des Systembenutzers',
    loadWorkplacesFailed: 'Arbeitsplätze konnten nicht geladen werden',
    workplacesUnauthorized: 'PT9800 hat Ihren PT9800-Benutzer nicht akzeptiert. Wählen Sie einen PT9800-Benutzer mit Zugriff auf diese Datenbank.',
    loadFailed: 'Benutzerzuordnung konnte nicht geladen werden',
    saveFailed: 'Benutzerzuordnung konnte nicht gespeichert werden',
    currentUserMissing: {
      summary: 'Ihr Benutzer ist keinem PT9800-Benutzer zugeordnet',
      details: 'Bitten Sie einen Benutzerverwalter, Ihren Benutzer in der Benutzerverwaltung einem PT9800-Benutzer zuzuordnen, und öffnen Sie den Import dann erneut.',
    },
    systemUserReason: {
      summary: 'Warum der Systembenutzer einen PT9800-Benutzer braucht',
      details: 'Qmulus synchronisiert die Chargen, Signale, Alarme und Rezepte der importierten Arbeitsplätze im Hintergrund als Systembenutzer. Ohne PT9800-Benutzer für den Systembenutzer bleiben die importierten Arbeitsplätze leer.',
    },
    systemUserUnknown: {
      summary: 'Benutzerzuordnung des Systembenutzers prüfen',
      details: 'Importierte Arbeitsplätze werden nur synchronisiert, wenn der Systembenutzer einem PT9800-Benutzer zugeordnet ist. Bitten Sie einen Benutzerverwalter, dies in der Benutzerverwaltung zu prüfen.',
    },
  },
  location: {
    header: 'Standort',
    description: 'Wählen Sie den Standort, in den die Arbeitsplätze importiert werden.',
    linkedToOtherDataSource: {
      summary: 'Standort gehört zu einer anderen PT9800-Installation',
      details: 'Dieser Standort ist bereits mit {dataSources} verknüpft. Prüfen Sie, ob Sie den richtigen Standort gewählt haben.',
    },
    notLinked: {
      summary: 'Standort wird verknüpft',
      details: 'Der Import verknüpft diesen Standort mit {dataSource}.',
    },
  },
  workplaces: {
    header: 'Arbeitsplätze',
    empty: 'Diese PT9800-Installation hat keine Arbeitsplätze, die importiert werden können.',
    nameRequired: 'Geben Sie einen Namen ein.',
    licenseExceeded: '{level}: keine Lizenzen mehr frei. Ihre Lizenz erlaubt {allowed}.',
    licenseLimitReached: 'Lizenzgrenze erreicht',
    licenseUsage: '{level}: {used} von {allowed} Lizenzen belegt, einschließlich der ausgewählten Arbeitsplätze.',
  },
  state: {
    waiting: 'Wartend',
    importing: 'Wird importiert',
    imported: 'Importiert',
    failed: 'Fehlgeschlagen',
    alreadyImported: 'Bereits importiert',
  },
  progress: {
    current: 'Schritt {current} von {total}: {step}',
    finished: 'Import abgeschlossen',
    failed: 'Fehlgeschlagen: {step}',
    step: {
      linkLocation: 'Standort „{name}“ mit Datenquelle verknüpfen',
      createAsset: '„{name}“ anlegen',
      loadChambers: 'Kammern von „{name}“ laden',
      linkAsset: '„{name}“ mit Datenquelle verknüpfen',
    },
  },
};
